export default "__VITE_ASSET__qvpjqwrX__"